module.exports = __webpack_public_path__ + "static/media/esx-es5.22ba4c9f.svg";